module.exports = __webpack_public_path__ + "media/src/images/partners/glu-62b0456abb46a8290fb97b6fb39734f9.jpg";